import AuthModule from "~/api/modules/auth";
import BookingModule from "~/api/modules/booking";
import CustomerModule from "~/api/modules/customer";
import GiftCardModule from "~/api/modules/giftcard";
import LocationModule from "~/api/modules/location";
import MarketingModule from "~/api/modules/marketing";
import PassModule from "~/api/modules/pass";

export interface ApiInstance {
  auth: AuthModule
  booking: BookingModule
  customer: CustomerModule
  giftcard: GiftCardModule
  location: LocationModule
  marketing: MarketingModule
  pass: PassModule,
  ACTION_INFO: string,
  ACTION_VALIDATE: string,
  ACTION_INTEGRATION: string,
  ACTION_CONFIRM: string
}

export default defineNuxtPlugin((nuxtApp) => {
  const modules: ApiInstance = {
    auth: new AuthModule(),
    booking: new BookingModule(),
    customer: new CustomerModule(),
    giftcard: new GiftCardModule(),
    location: new LocationModule(),
    marketing: new MarketingModule(),
    pass: new PassModule(),
    ACTION_INFO: 'info',
    ACTION_VALIDATE: 'validate',
    ACTION_INTEGRATION: 'integration',
    ACTION_CONFIRM: 'confirm'
  }

  nuxtApp.provide('api', modules)
})

